export var OrderChargeType;
(function (OrderChargeType) {
    OrderChargeType["FEE"] = "FEE";
    OrderChargeType["DISCOUNT"] = "DISCOUNT";
})(OrderChargeType || (OrderChargeType = {}));
